export default __webpack_public_path__ + "static/media/slide5-2za8tima4ci25wo4wwkpvu.04b8c4c4.jpg";